import {randIntRange} from './utils'

class Vector2  {

    constructor(x = 0, y = 0) {
        this.x = x;
        this.y = y;
    }

    randomizeInRange(xMin = -1, xMax = 1, yMin = -1, yMax=1) {
      this.x = randIntRange(xMin, xMax);
      this.y = randIntRange(yMin, yMax);
      return this;
    }

    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }

    addVectors(a, b) {
      this.x = a.x + b.x;
      this.y = a.y + b.y;
      return this;
    }

    subVectors( a, b ) {
	  	this.x = a.x - b.x;
	  	this.y = a.y - b.y;
		  return this;
	}

   copy(){
     return new Vector2(this.x, this.y);
   }

    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }

    round() {
        this.x  = ~~ (this.x+0.5);
        this.y = ~~ (this.y+0.5);
    }
}

export {Vector2}